import React from "react";

export const FormFieldLabel: React.FC<{
  label: string;
  bold?: boolean;
  required?: boolean;
}> = ({ label, bold = true, required }) => {
  return (
    <label className={bold ? "label" : ""}>
      {label}
      {required && (
        <span className="icon has-text-danger is-size-7">
          <i className="fas fa-asterisk" />
        </span>
      )}
    </label>
  );
};
